type FundingProgramLike = {
    id: number,
    parent_funding_program_id?: number | null,
}

type YearLike = {
    id: number,
    fundingAreas?: { funding_program_id: number, process_creation_enabled: boolean }[] | null,
}

/**
 * Whether new processes may be created per year and funding area (top-level funding program).
 * Forms in existing processes are not affected by this.
 */
export function useYearFundingAreas() {
    function fundingAreaIdOf(fundingProgram: FundingProgramLike): number {
        return fundingProgram.parent_funding_program_id ?? fundingProgram.id
    }

    function enabledFundingAreaIds(year: YearLike | null | undefined): number[] {
        return (year?.fundingAreas ?? [])
            .filter(fundingArea => fundingArea.process_creation_enabled)
            .map(fundingArea => fundingArea.funding_program_id)
    }

    function isProcessCreationEnabled(year: YearLike | null | undefined, fundingProgram?: FundingProgramLike | null): boolean {
        const enabledIds = enabledFundingAreaIds(year)
        if (!fundingProgram) {
            return enabledIds.length > 0
        }

        return enabledIds.includes(fundingAreaIdOf(fundingProgram))
    }

    return {
        fundingAreaIdOf,
        enabledFundingAreaIds,
        isProcessCreationEnabled,
    }
}
